<template>
 
<ui-button-options v-on:click.native.stop="viewChat(item)" :subtitle="createSubtitle(item)" :title="getTitle(item)" :date="getDate(item)">
      <div slot="left">
        <img @error="imgLoadError" class="img-icon" :src="getAvatarSrc(item)">
      </div>
     
      <div slot="subtitle">
        <div class="sub">
          <ui-chip backgroundColor="#888888"  class="chip-child" icon="child" v-for="(item, index) in item.children" :key="index">
          {{item.name}}:{{item.group.toLowerCase()}}
          </ui-chip>
          <ui-chip backgroundColor="#50c0db"  class="chip-child" icon="users" v-for="(groupname, index) in item.teach_groups" :key="index">
          {{groupname}}
          </ui-chip>
        </div>
      </div>
     <!--
      <div slot="options" v-if="computeUserAccess">
       
        <ui-option title="language.edit" v-on:click.native.stop.prevent="edit_absence(item.id)" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
        <ui-option title="language.report_fit_again" v-on:click.native.stop.prevent="delete_absence(item.id)" backgroundColor="rgb(140, 198, 62)" color="#FFFFFF" icon="thermometer"/>
       
      </div>
    -->
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
//import UiOption from '../UiOption.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';
import  UiChip from '../../components/UiChip.vue';
    
export default {
  name: 'button-chat-person',
  props:{
    item:{default:{id:0}},
  },
  data:function(){
    return {
      
    }
  },
  computed:{
    ...mapState([
       'appSettings','group'
      ]),
    computeUserAccess(){
      
        //var isInGlobal=(this.$router.currentRoute.path=='/documents');
        //if(!this.group.authorized && !isInGlobal ){
          // if we are in a group
         //  return false;
         //}
       
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
        
    }
  },
  methods:{
    getAvatarSrc(item){
      //var timestamp="?ts="+new Date().getTime();
      
      //return item.avatar ? item.avatar+timestamp : undefined;
      return item.avatar ? item.avatar : this.composeReactionAvatar(item);
    },
    composeReactionAvatar(item){

      return helper.composeAvatarImage(item.name);

    },
    getDate(item){
      
      return helper.convertChatDate(item.last_chat.datetime);

    },
    getTitle(item){
      return item.name;
    },
    createSubtitle(item){

      var excerpt=helper.getExcerpt(item.last_chat.message,"...",150);
      return excerpt;
      
    },
    createIntroText(txt){
      return helper.getExcerpt(txt);
    },
    viewChat(item){
      
      this.$router.push({path:'/chat/'+item.id})
    },
    
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    imgLoadError(event){
      
      event.target.src=require('../../assets/default_avatar.png');
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    UiChip,
    //UiOption,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
.sub{
  margin-top:4px;
}
.chip-child{
  margin-right:2px;
  margin-bottom:2px;
  display: inline-block;
}
</style>
